import React, { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import Footer from "examples/Footer";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { Edit, Delete } from "@mui/icons-material";
function Teamfeedback() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
    </DashboardLayout>
  );
}
export default Teamfeedback;
